<template>
  <v-app
    id="inspire"
    :style="{ zoom: currentZoom }">
    <v-overlay :value="$store.getters.hasPendingAjax">
      <v-progress-circular
        :size="70"
        :width="7"
        indeterminate
        color="primary" />
    </v-overlay>
    <v-app-bar
      app
      clipped-left
      dark
      color="blue darken-3"
      dense>
      <v-toolbar-title class="mr-12 align-center">
        <span class="title">
          SRDMアスベストリポートクリエーター
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <template
        v-if="isLoggedIn">
        <v-btn
          icon
          small
          :disabled="currentZoom<0.5"
          @click.prevent="onZoomOutClicked">
          <v-icon>
            mdi-magnify-minus-outline
          </v-icon>
        </v-btn>
        <v-btn
          text
          small
          :disabled="currentZoom===1.0"
          @click.prevent="onZoomResetClicked">
          {{ Math.floor(currentZoom * 100) }}%
        </v-btn>
        <v-btn
          icon
          small
          :disabled="currentZoom>2"
          @click.prevent="onZoomInClicked">
          <v-icon>
            mdi-magnify-plus-outline
          </v-icon>
        </v-btn>
      </template>
      <v-menu
        v-if="isLoggedIn"
        bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            text
            class="pr-3"
            v-on="on">
            <v-icon>mdi-account</v-icon>
            {{ userName }}
            ({{ userId }})
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item dense>
            <v-list-item-subtitle>
              ログインID
            </v-list-item-subtitle>
            <v-list-item-title>
              {{ userId }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item dense>
            <v-list-item-subtitle>
              氏名
            </v-list-item-subtitle>
            <v-list-item-title>
              {{ userName }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item dense>
            <v-list-item-subtitle>
              ブロック
            </v-list-item-subtitle>
            <v-list-item-title>
              {{ blockName }}
            </v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item
            @click="onAccountButtonClicked">
            <v-list-item-title>
              <v-icon>
                mdi-lock
              </v-icon>
              パスワードの変更
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            @click="onProfileButtonClicked">
            <v-list-item-title>
              <v-icon>
                mdi-account-box
              </v-icon>
              会員情報の変更
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="$store.state.auth.permission >= 2"
            @click="onAdminButtonClicked">
            <v-list-item-title>
              <v-icon>
                mdi-cloud-lock
              </v-icon>
              管理者メニュー
            </v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item
            @click="onLogoutClicked">
            <v-list-item-title>
              <v-icon>
                mdi-logout
              </v-icon>
              ログアウト
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-main>
      <v-container fluid>
        <v-breadcrumbs
          v-if="isLoggedIn && breadcrumbs.length > 1"
          large
          :items="breadcrumbs">
          <template v-slot:divider>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
        </v-breadcrumbs>
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-dialog
      v-model="logoutDialogIsShown"
      max-width="290">
      <v-card>
        <v-card-title class="headline">
          ログアウトしますか？
        </v-card-title>
        <v-card-text>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary darken-1"
            @click.prevent="logoutDialogIsShown=false">
            いいえ
          </v-btn>
          <v-btn
            color="error darken-1"
            @click="onLogoutOkClicked">
            はい
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="hasSystemMessage"
      :value="true"
      top
      rounded
      centered
      multi-line
      :light="$store.state.systemMessage.light"
      :color="$store.state.systemMessage.color"
      :timeout="$store.state.systemMessage.timeout">
      <template v-if="$store.state.systemMessage.title">
        <v-icon left>{{ $store.state.systemMessage.icon }}</v-icon>
        {{ $store.state.systemMessage.title }}
      </template>
      <pre class="ml-5">{{ $store.state.systemMessage.message }}</pre>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'MainContainer',
  components: { },
  data: () => ({
    logoutDialogIsShown: false,
    currentZoom: 1.0,
  }),
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('progress', ['loadedProgress']),
    ...mapMutations(['resetSystemMessage']),
    blockName() {
      return this.$store.state.auth.block.name
    },
    userName() {
      return this.$store.state.auth.name
    },
    userId() {
      return this.$store.state.auth.login_id
    },
    breadcrumbs() {
      const breadcrumbs = [
        {
          text: 'トップ',
          exact: true,
          icon: 'mdi-home',
          to: { name: 'index' },
        },
      ]
      if (this.$route.meta.breadcrumbs) {
        breadcrumbs.push(...this.$route.meta.breadcrumbs)
      }
      return breadcrumbs
    },
    hasSystemMessage: {
      get() {
        return this.$store.state.systemMessage.show
      },
      set(value) {
        if (!value) {
          this.$store.commit('resetSystemMessage')
        }
      },
    },
  },
  mounted() {
    const zoom = window.localStorage.getItem('currentZoom')
    if (zoom) {
      this.currentZoom = parseFloat(zoom, 10)
    }
  },
  methods: {
    onLogoutClicked() {
      this.logoutDialogIsShown = true
    },
    async onLogoutOkClicked() {
      this.logoutDialogIsShown = false
      try {
        await this.$store.dispatch('auth/logout')
        await this.$router.push('/login')
      } catch (err) {
        await this.$router.push('/admin')
      }
    },
    onAccountButtonClicked() {
      if (this.$route.name !== 'account') {
        this.$router.push({ name: 'account' })
      }
    },
    onAdminButtonClicked() {
      if (this.$route.name !== 'adminIndex') {
        this.$router.push({ name: 'adminIndex' })
      }
    },
    onProfileButtonClicked() {
      if (this.$route.name !== 'profile') {
        this.$router.push({ name: 'profile' })
      }
    },
    onZoomOutClicked() {
      if (this.currentZoom < 0.5) {
        return
      }
      this.currentZoom -= 0.1
      window.localStorage.setItem('currentZoom', this.currentZoom)
    },
    onZoomInClicked() {
      if (this.currentZoom > 1.5) {
        return
      }
      this.currentZoom += 0.1
      window.localStorage.setItem('currentZoom', this.currentZoom)
    },
    onZoomResetClicked() {
      this.currentZoom = 1.0
      window.localStorage.setItem('currentZoom', this.currentZoom)
    },
  },
}
</script>
